import { render, staticRenderFns } from "./crm-group-meta-data.vue?vue&type=template&id=6831a9ba&scoped=true&"
import script from "./crm-group-meta-data.vue?vue&type=script&lang=js&"
export * from "./crm-group-meta-data.vue?vue&type=script&lang=js&"
import style0 from "./crm-group-meta-data.vue?vue&type=style&index=0&id=6831a9ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6831a9ba",
  null
  
)

export default component.exports